import { getAxiosInstance } from "../http"

import { Appro } from "../models"

import { CashReception } from "../models"

export class DistributorService {

    static createAppro = async (data: any) => {

        const instance = getAxiosInstance()

        const response = await instance.post('distributors/appros', Appro.toJSON(data))

        const result = Appro.fromJSON(response.data)

        return result
    }

    static getRequestForApproList = async (): Promise<Appro[]> => {

        const instance = getAxiosInstance()

        const response = await instance.get('distributors/request-appros')

        const result = response.data.map((appro: any) => Appro.fromJSON(appro) as Appro)

        return result
    }

    static createRequestForAppro = async (id: string, status: string) => {

        const instance = getAxiosInstance()

        const response = await instance.put(`distributors/appros/${id}`, { status })

        const result = Appro.fromJSON(response.data)

        return result
    }

    static acceptRequestForAppro = async (id: number) => {

        const instance = getAxiosInstance()

        const response = await instance.put(`distributors/accept-request-appros/${id}`)

        const result = Appro.fromJSON(response.data)

        return result
    }

    static rejectRequestForAppro = async (id: number) => {

        const instance = getAxiosInstance()

        const response = await instance.put(`distributors/reject-request-appros/${id}`)

        const result = Appro.fromJSON(response.data)

        return result
    }

    static getCashReceptionHistory = async (): Promise<CashReception[]> => {

        const instance = getAxiosInstance()

        const response = await instance.get('distributors/receptions')

        const result = response.data.map((cr: any) => CashReception.fromJSON(cr) as CashReception)

        return result
    }

    static createCashReception = async (cashReception: CashReception): Promise<CashReception> => {

        const instance = getAxiosInstance()

        const response = await instance.post('distributors/receptions', CashReception.toJSON(cashReception))

        return CashReception.fromJSON(response.data)
    }

    static getMyTillStatus = async () => {

        const instance = getAxiosInstance()

        const response = await instance.get('distributors/is-till-currently-opened')

        return response.data
    }

    static openMyTill = async () => {
        
        const instance = getAxiosInstance()

        const now = new Date().toISOString()

        const payload = JSON.stringify({opening_comment: `Opening till at ${now}`})

        const response = await instance.post('distributors/open-till', payload)

        return response.data
    }

    static getPreviousDailyReport = async () => {

        const instance = getAxiosInstance()

        const response = await instance.get('distributors/previous-dailyreport')

        return response.data
    }

    static getAllMyDailyReports = async () => {

        const instance = getAxiosInstance()

        const response = await instance.get('shared/all-my-dailyreports')

        return response.data
    }

}